import React from 'react';
import { useSelector } from 'react-redux';
import NavigationMegaMenu from './Navigation.MegaMenu';

const Navigation = ({
  contentLinks = [],
  onLinkHover,
  onMouseLeaveLink,
  activeMegaMenuLink,
  onMegaMenuClose,
}) => {
  const menuLinks = contentLinks;

  return (
    <div className="header__menu show-for-medium">
      {menuLinks.map((link) => (
        <NavigationLink
          key={link.url + link.name}
          link={link}
          isActive={link.links?.length > 0 && activeMegaMenuLink == link}
          onLinkHover={() => onLinkHover(link)}
          onMouseLeaveLink={onMouseLeaveLink}
          onMegaMenuClose={onMegaMenuClose}
        />
      ))}
    </div>
  );
};

const NavigationLink = ({
  link,
  isActive,
  onLinkHover,
  onMouseLeaveLink,
  onMegaMenuClose,
}) => (
  <>
    <a
      key={link.url + link.name}
      href={link.url || '#'}
      className={`${link.isSelected ? 'selected' : ''} ${
        isActive ? 'active' : ''
      }`}
      onMouseOver={onLinkHover}
      onMouseLeave={onMouseLeaveLink}
    >
      {link.name}
    </a>
    {link.links?.length > 0 && (
      <NavigationMegaMenu
        onMegaMenuClose={onMegaMenuClose}
        onMouseLeaveMegaMenu={onMouseLeaveLink}
        onMouseOverMegaMenu={() => onLinkHover(link)}
        link={link}
        open={isActive}
      />
    )}
  </>
);

export default Navigation;
